import React from 'react';
import { useTranslation } from 'react-i18next';

import Link from '../../../components/link';
import { cdn } from '../../../helpers/urls';
import { Button } from '../../../styled-components/components/Button';
import { getStaticMarketPath } from '../../../utils/market';
import { resolveAssignmentRoute } from '../../utils';

const SellYourCar = () => {
  const { t } = useTranslation('startpage');

  return (
    <section className="page-section" aria-label="Sälj din bil">
      <div data-wx-articlecard="video cursor-unset">
        <div
          className="article-card-image"
          style={{
            backgroundImage: `url(${cdn(
              `/images/${getStaticMarketPath()}/startpage/sell-your-car/sell_your_car_card_bg.jpg`,
            )})`,
          }}
        />
        <div className="article-card-body">
          <div data-wx-label="light" className="article-card-pre-heading">
            {t('Sell your car', { ns: 'startpage' })}
          </div>
          <div className="article-card-heading">
            {t('Sell your car safely, quickly and completely free of charge', { ns: 'startpage' })}
          </div>
          <div className="article-card-preamble">
            {t('You receive offers from several traders - and do not commit to anything.', {
              ns: 'startpage',
            })}
          </div>
          <div className="article-card-footer">
            <Button
              as={Link}
              to={`/${resolveAssignmentRoute()}`}
              title={t('Get started selling your car', { ns: 'startpage' })}
              data-wayke-action="assignment-push"
              $tone="primary"
              $inline
            >
              {t('Get started', { ns: 'startpage' })}
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SellYourCar;
